import EventSystem from './utils/EventSystem';

class Links {
  // Initialization
  constructor() {
    // Get dimensions
    this.width = document.body.clientWidth;
    this.height = document.body.clientHeight;

    // Define colors
    this.colors = ['#1f6ada', '#ff3900', '#00cc99'];

    // Define level names
    this.levelNames = [
      'Nível 0', 'Nível 1', 'Nível 2', 'Nível 3', 'Nível 4', 'Nível 5', 'Nível 6', 'Nível 7', 'Nível 8', 'Nível 9', 'Nível 10', 'Nível 11', 'Nível 12', 'Nível 13'];

    // Define drawing vars
    this.treeBackgroundPadding = 50;

    this.hidden = true;

    this.container = d3.select('.links')
      .style('display', 'none')
      ;

    // Get Canvas container
    this.canvas = this.container.append('canvas');

    // Set sizes
    this.canvas.property('width', this.width);
    this.canvas.property('height', this.height);

    // Get Labels container
    this.labelContainer = d3.select('.labels');

    // Get canvas element
    this.ctx = this.canvas.node().getContext('2d');

    // Get current d3 transform
    this.transform = d3.zoomIdentity;

    this.simulation = d3.forceSimulation()
      .alphaDecay(0.01)
      .force('link', d3.forceLink().distance(l => l.value === 2 ? 30 : 60).id(function(d) { return d.id; }))
      .force('collide', d3.forceCollide()/*.radius(l => l.value === 2 ? 20 : 25)*/.iterations(2))
      .force('charge', d3.forceManyBody(-1).distanceMax(300))
      .force('center', d3.forceCenter(this.width / 2, this.height / 2))
      // .force('forceCenter', (alpha) => {
      //   var nodes = spheres.simulation.nodes();
      //   for (var i = 0, n = nodes.length, node, k = alpha * 0.001; i < n; ++i) {
      //     node = nodes[i];
      //     node.vx -= node.x * k;
      //     node.vy -= node.y * k;
      //   }
      // })
      ;

    // Call to draw first canvas frame
    this.drawCanvas();

    // Events
    // EventSystem.$on('area-changed', area => {
    //   this.hide(() => {
    //     this.nodes.sort((a, b) => (a.direction === area ? -1 : (b.direction === area ? 1 : -1)));
    //     this.createMap(this.nodes);
    //     this.filterNodes({ area });
    //     this.show();
    //   });
    // });
    // EventSystem.$on('front-changed', front => {
    //   this.hide(() => {
    //     this.filteredNodes = undefined;
    //     this.loadFront(front.file);
    //     this.show();
    //   });
    // });
    EventSystem.$on('tree-view-close', () => {
      this.selectedNode = null;
    });
    EventSystem.$on('selected-node', node => {
      if (this.hidden) return;
      this.collidingNode = this.nodes.find(n => n.id === node.id);
      this.selectedNode = this.collidingNode;
      this.canvasClick();
    });
  }

  // Draw Functions
  drawCanvas() {
    // Call to draw canvas
    requestAnimFrame(() => { this.drawCanvas() });

    var startTime = performance.now();

    this.ctx.fillStyle = '#E8F5FB';
    this.ctx.fillRect(0, 0, this.width, this.height);
    this.drawSimulation();

    window.drawDelta = performance.now() - startTime;
  }
  drawSimulation() {
    // Draw canvas nodes using D3 force layout
    // Update labels position
    if (this.collidingNode) {
      var el = document.querySelector(`#label-${this.collidingNode.id}`);
      if (el) {
        var x = this.nodeX - Math.round(el.offsetWidth / 2);
        var y = this.nodeY - (30 * d3.easeCubicOut(1 - (this.transform.k / 8))) - Math.round(el.offsetHeight / 2);
        el.style.left = `${x}px`;
        el.style.top = `${y}px`;
      }
    }

    if (!this.links || !this.nodes) return;

    var nodes = this.filteredNodes || this.nodes;
    var links = this.links;
    var ctx = this.ctx;

    ctx.save();
    ctx.translate(this.transform.x, this.transform.y);
    ctx.scale(this.transform.k, this.transform.k);
    ctx.fillStyle = '#333';
    ctx.lineWidth = 3;

    links.forEach(l => {
      ctx.beginPath();
      ctx.setLineDash(l.value === 0 ? [] : [3, 3]);
      ctx.moveTo(l.source.x, l.source.y);
      ctx.lineTo(l.target.x, l.target.y);
      ctx.stroke();
    });

    nodes.forEach(n => this.drawNode(n));

    var closest = this.getClosestNode(nodes);

    ctx.fillStyle = '#333';
    if (closest) {
      if (this.collidingNode) {
        this.labelHover(this.collidingNode, 0);
      }
      this.labelHover(closest.node, 1);

      this.collidingNode = closest.node;

      // this.drawNode({ ...closest.node, radius: 26 });
      this.drawNode(closest.node, true);
    } else {
      if (this.collidingNode) {
        this.labelHover(this.collidingNode, 0);
      }
      this.collidingNode = undefined;
    }

    if (this.selectedNode) {
      this.drawNode(this.selectedNode, true);
    }

    ctx.restore();
  }
  drawNode(node, selected) {
    // Draws single node
    var ctx = this.ctx;

    ctx.beginPath();
    ctx.fillStyle = ctx.strokeStyle = node.color || this.colors[node.group];
    if (selected) {
      ctx.setLineDash([]);
      ctx.lineWidth = 2;
      ctx.arc(node.x, node.y, node.r ? node.r + 5 : 24, 0, Math.PI * 2);
      ctx.stroke();
      ctx.beginPath();
    }
    ctx.arc(node.x, node.y, node.r || 22, 0, Math.PI * 2);
    ctx.fill();
  }
  drawDebug() {
    if (window.meanTime75) {
      window.meanTime75 = (window.meanTime75 * 0.75) + (window.drawDelta * 0.25);
      window.meanTime99 = (window.meanTime99 * 0.99) + (window.drawDelta * 0.01);
      window.meanTime995 = (window.meanTime995 * 0.995) + (window.drawDelta * 0.005);
    } else {
      window.meanTime75 = window.drawDelta;
      window.meanTime99 = window.drawDelta;
      window.meanTime995 = window.drawDelta;
    }

    if (window.meanTimeSimul75) {
      window.meanTimeSimul75 = (window.meanTimeSimul75 * 0.75) + (window.simulationDelta * 0.25);
      window.meanTimeSimul99 = (window.meanTimeSimul99 * 0.99) + (window.simulationDelta * 0.01);
      window.meanTimeSimul995 = (window.meanTimeSimul995 * 0.995) + (window.simulationDelta * 0.005);
    } else {
      window.meanTimeSimul75 = window.simulationDelta;
      window.meanTimeSimul99 = window.simulationDelta;
      window.meanTimeSimul995 = window.simulationDelta;
    }

    var ctx = this.ctx;
    var messages = [
      `[ DRAW TIME ]`,
      `|  [Instant]   ${Math.round(window.drawDelta * 10) / 10} ms`,
      `|  [75%]       ${Math.round(window.meanTime75 * 10) / 10} ms`,
      `|  [99%]       ${Math.round(window.meanTime99 * 10) / 10} ms`,
      `|  [99.5%]     ${Math.round(window.meanTime995 * 10) / 10} ms`,
      '',
      '',
      `[ SIMULATION TIME ]`,
      `|  [Instant]   ${Math.round(window.simulationDelta * 10) / 10} ms`,
      `|  [75%]       ${Math.round(window.meanTimeSimul75 * 10) / 10} ms`,
      `|  [99%]       ${Math.round(window.meanTimeSimul99 * 10) / 10} ms`,
      `|  [99.5%]     ${Math.round(window.meanTimeSimul995 * 10) / 10} ms`];
    var offset = this.height - (messages.length * 15);

    ctx.font = '600 10px Courier, arial';
    ctx.fillStyle = '#FFF';
    ctx.globalAlpha = 0.8;
    ctx.fillRect(0, offset - 15, 150, this.height);
    ctx.fillStyle = '#333';
    ctx.globalAlpha = 1;
    messages.forEach((m, i) => {
      ctx.fillText(m, 10, offset + (i * 15));
    });
  }

  // General Utils
  updateView(nodes) {
    this.nodes = nodes;
    this.links = window.$links.map(l => ({
      ...l,
      // source: nodes.find(n => n.id === l.source),
      // target: nodes.find(n => n.id === l.target),
    })).filter(l => {
      return nodes.find(n => n.id === l.source) && nodes.find(n => n.id === l.target);
      // return l.souce && l.target;
    });

    this.simulation
      .nodes(nodes)
    ;
    this.simulation
      .force('link')
      .links(this.links)
    ;

    this.simulation
      .alpha(1)
      .restart()
  }
  // recalcLabelPositions() {
  //   // Recalculates all label positions given node new position
  //   this.animationCoordinator.animation.labelsfadein.forEach(al => {
  //     var el = al.label;
  //     var x = al.node.x - Math.round((el.offsetWidth / this.transform.k) / 2);
  //     var y = al.node.y - Math.round((el.offsetHeight / this.transform.k) / 2);
  //     el.style.left = `${(x * this.transform.k) + this.transform.x}px`;
  //     el.style.top = `${(y * this.transform.k) + this.transform.y}px`;
  //   });
  // }
  // undoAnimation() {
  //   // Unodes Tree Animation
  //   this.animationCoordinator.durations = [200, 450, 450];
  //   this.animationCoordinator.animation.zoomin.fromK = this.transform.k;
  //   this.animationCoordinator.animation.zoomin.fromX = this.transform.x;
  //   this.animationCoordinator.animation.zoomin.fromY = this.transform.y;
  //   this.animationCoordinator.phases = [/*'labelsfadeout' ,*/'unposition', 'zoomfadein', 'end'];
  // }
  collidePrecise(n1, n2) {
    return (
      ((n2.x - n1.x) ** 2) +
      ((n2.y - n1.y) ** 2) <
      ((n1.r + n2.r) ** 2)
    )
  }
  hide() {
    this.animateOut();
    this.hidden = true;
    // this.container.style('display', 'none');
  }
  show() {
    // Register drag, zoom and other events for canvas
    this.labelContainer
      .call(d3
        .drag()
        .subject(() => this.canvasDragSubject())
        .on('start', () => this.canvasDragStart())
        .on('drag', () => this.canvasDragged())
        .on('end', () => this.canvasDragEnded())
      )
      .call(d3
        .zoom()
        .scaleExtent([0.125, 2])
        .on('zoom', () => this.canvasZoomed())
      )
      .on('dblclick.zoom', null)
      .on('click', () => this.canvasClick())
      .on('mousemove', () => this.canvasMouseMove())
    ;
    this.animateIn();
    this.hidden = false;
    // this.container.style('display', 'block');
  }
  animateIn() {
    this.container
      .style('opacity', 0)
      .style('display', 'block')
      .transition()
        .duration(150)
        .style('opacity', 1)
      ;
  }
  animateOut() {
    this.container
      .transition()
        .duration(150)
        .style('opacity', 0)
        .style('display', 'none')
  }
  // Node Utils
  depthSearch(ns) {
    // Depth-first search for all child nodes using the links
    var cnode = ns.currentNode;
    var currentSubLevel = ns.lastLevel === cnode.nivel ? ns.lastSubLevel + 1 : 0

    if (currentSubLevel > 0) {
      ns.currentNode.referenceNode = ns.lastNode;
    }

    if (ns.treeViewLayers[cnode.nivel]) {
      if (ns.treeViewLayers[cnode.nivel][currentSubLevel]) {
        ns.treeViewLayers[cnode.nivel][currentSubLevel].push(cnode);
      } else {
        ns.treeViewLayers[cnode.nivel][currentSubLevel] = [cnode];
      }
    } else {
      ns.treeViewLayers[cnode.nivel] = [[cnode]];
    }

    var children = this.links.filter(l => (
      l.target.id === cnode.id &&
      !ns.targetNodesIds.has(l.source.id)
    ));
    ns.targetNodesIds.add(cnode.id);

    children.forEach(c => {
      this.depthSearch({
        ...ns,
        lastNode: cnode,
        currentNode: this.nodes.find(n => n.id === c.source.id),
        lastLevel: cnode.nivel,
        lastSubLevel: currentSubLevel,
      });
    });
  }
  distance(n) {
    // Measure colliding distance for nodes
    if (Math.abs(this.mouseX - n.x) < 22 &&
        Math.abs(this.mouseY - n.y) < 22) {
      return ((this.mouseX - n.x) ** 2) + ((this.mouseY - n.y) ** 2);
    }
    return null
  }
  getClosestNode(nodes) {
    var closest = { dist: Infinity, node: null };
    nodes.forEach(n => {
      var dist = this.distance(n);
      if (dist && dist < closest.dist) {
        closest = { dist: dist, node: n };
      }
    });

    return closest.node ? closest : null;
  }
  studyNodes() {
    // Gather nodes and links information based on the current colliding node
    var layers = [];
    this.nodes.forEach(n => {
      layers[n.nivel] = layers[n.nivel] ? [...layers[n.nivel], n] : [n];
    });

    var struct = {
      lastNode: null,
      currentNode: this.collidingNode,
      lastLevel: 0,
      lastSubLevel: 0,
      treeViewLayers: [],
      targetNodesIds: new Set(),
      linksList: new Set(),
    };
    this.depthSearch(struct);

    return { layers, dsearch: struct };
  }
  // createMap(nodes) {
  //   this.balls = [];
  //   var angle = 0;
  //   var radius = 0;
  //   var maxIterations = 100000;
  //   var iterations = 0;
  //   return nodes.forEach(n => {
  //     if (++iterations > maxIterations) {
  //       return;
  //     }
  //     var collided;
  //     var r = ((+n.nivel / 13) * 20) + 15;
  //     do {
  //       var x = Math.cos(angle) * radius * Math.max(0.85, Math.random());
  //       var y = Math.sin(angle) * radius * Math.max(0.85, Math.random()) * 0.85;

  //       collided = false;

  //       this.balls.forEach(b => {
  //         // if (this.collideBroad(b, { x, y, r })) {
  //           if (this.collidePrecise(b, { x, y, r })) {
  //             collided = true;
  //           }
  //         // }
  //       });
  //       if (angle <= 350) {
  //         // angle += Math.max(1, 30 * (radius / this.width)) * Math.random();
  //         angle += Math.random()
  //       } else {
  //         angle = (360 + Math.max(1, 10 * (radius / this.width))) - angle;
  //         radius += 10;
  //       }
  //     } while (collided);
  //     this.balls.push({ x, y, r });
  //     // return { ...n, x: x + (this.width / 2), y: y + (this.height / 2), r: r * 0.8 };

  //     n.x = x + (this.width / 2);
  //     n.y = y + (this.height / 2);
  //     n.r = r * 0.8;
  //   });
  // }
  // filterNodes(args) {
  //   if (args.area) {
  //     if (args.area === 'Todas') {
  //       this.filteredNodes = undefined;
  //     } else {
  //       var filteredNodes = this.nodes.filter(n => n.direction === args.area);
  //       this.filteredNodes = filteredNodes;
  //     }
  //   }
  // }

  // Events
  canvasZoomed() {
    // Callback on canvas zoom event
    this.transform = d3.event.transform;
  }
  canvasDragStart() {
    // Callback on canvas start drag element
    this.isDragging = true;
    this.nodeDragged = d3.event.subject;
    this.lastMousePosX = d3.event.subject.x = this.transform.invertX(d3.event.x);
    this.lastMousePosY = d3.event.subject.y = this.transform.invertY(d3.event.y);
  }
  canvasDragged() {
    // Callback on canvas panning
    this.simulation.alpha(1).restart();
    this.lastMousePosX = d3.event.subject.x = this.transform.invertX(d3.event.x);
    this.lastMousePosY = d3.event.subject.y = this.transform.invertY(d3.event.y);
  }
  canvasDragSubject() {
    // Callback on canvas drag element
    var i;
    var x = this.transform.invertX(d3.event.x);
    var y = this.transform.invertY(d3.event.y);
    var dx;
    var dy;

    for (i = this.nodes.length - 1; i >= 0; --i) {
      var node = this.nodes[i];
      dx = x - node.x;
      dy = y - node.y;
      if (dx * dx + dy * dy < 25 * 25) {
        node.x = this.transform.applyX(node.x);
        node.y = this.transform.applyY(node.y);
        this.isDragging = true;
        this.nodeDragged = node;
        return node;
      }
    }
  }
  canvasDragEnded() {
    // Callback on canvas end drag element
    this.isDragging = false;
    this.nodeDragged = undefined;
  }
  canvasClick() {
    if (!this.collidingNode) return;
    // Callback for node clicked
    // If no node was clicked
    // if (this.nodeClickDisabled) {
    //   this.preSelectedNode = this.collidingNode;
    //   EventSystem.$emit('tree-view-node-click', this.collidingNode);
    //   return;
    // }

    // Hide current label
    this.selectedNode = this.collidingNode;
    EventSystem.$emit('tree-view-open', this.collidingNode);
    // this.labelHover(this.collidingNode, 0);
    // this.labelhoverDisabled = true;
    // this.nodeClickDisabled = true;
    // this.preSelectedNode = this.collidingNode;
    // // this.disableDrag();
    // // this.disableZoom();

    // var study = this.studyNodes();
    // var struct = study.dsearch;
    // struct.treeViewLayers = struct.treeViewLayers.filter(l => l);
    // struct.nodes = [];
    // struct.links = this.links.filter(l => (
    //   struct.targetNodesIds.has(l.source.id)
    //   &&
    //   struct.targetNodesIds.has(l.target.id)
    // ));

    // // var heightSteps = Math.max(200, this.height / (struct.treeViewLayers.length + 1));
    // var heightSteps = (this.height - 200) / (struct.treeViewLayers.length);
    // var offsetBase = 0;

    // if (heightSteps >= 200) {
    //   offsetBase = ((heightSteps - 200) * (struct.treeViewLayers.length)) / 2;
    //   heightSteps = 200;
    // }

    // struct.treeViewLayers.forEach((layer, y) => {
    //   var iy = (struct.treeViewLayers.length - 1) - y;
    //   var ySubStep;
    //   if (layer.length > 1) {
    //     ySubStep = heightSteps / (layer.length + 1);
    //   } else {
    //     ySubStep = heightSteps / 2;
    //   }
    //   var yBase = (iy * heightSteps) + ySubStep + offsetBase;

    //   layer.forEach((subLayer, yoff) => {
    //     var iyoff = (layer.length - 1) - yoff;
    //     subLayer.forEach((node, x) => {
    //       if (yoff > 0 && subLayer.length === 1) {
    //         node.originX = node.x;
    //         node.originY = node.y;
    //         node.targetX = node.referenceNode.targetX;
    //         node.targetY = yBase + (iyoff * ySubStep) + 90;
    //       } else {
    //         node.originX = node.x;
    //         node.originY = node.y;
    //       node.targetX = (((x + 1) * (this.width - 800)) / (subLayer.length + 1)) + 600;
    //         node.targetY = yBase + (iyoff * ySubStep) + 90;
    //       }
    //       node.underLayer = yoff !== layer.length - 1;
    //       struct.nodes.push(node);
    //     });
    //   });
    // });

    // EventSystem.$emit('tree-view-data', {
    //   hSteps: heightSteps,
    //   height: this.height - 200,
    //   width: this.width - 361,
    //   layers: JSON.parse(JSON.stringify(struct.treeViewLayers)),
    // });

    // // Set variables for canvas animation
    // this.animationStruct = struct;
    // this.animationCoordinator = {
    //   durations: [450, 450/*, 200*/],
    //   phases: ['zoomfadeout', 'position'/*, 'labelsfadein'*/],
    //   selectedNodeId: this.collidingNode.id,
    //   started: new Date().getTime(),
    //   verticalPad: heightSteps,
    //   animation: {
    //     zoomout: {
    //       fromK: this.transform.k, fromX: this.transform.x, fromY: this.transform.y,
    //     },
    //     zoomin: {
    //       toK: this.transform.k, toX: this.transform.x, toY: this.transform.y,
    //     },
    //     labelsfadein: Array.from(struct.targetNodesIds).map(id => ({
    //       label: document.querySelector(`#label-${id}`),
    //       node: struct.nodes.find(n => n.id === id),
    //       positioned: false,
    //     })),
    //   },
    // };
    // this.animatingNodes = true;
  }
  canvasMouseMove() {
    // Callback on canvas mouse move
    this.mouseX = (d3.event.pageX - this.transform.x) / this.transform.k;
    this.mouseY = (d3.event.pageY - this.transform.y) / this.transform.k;
    if (this.collidingNode) {
      this.nodeX = (this.collidingNode.x * this.transform.k) + this.transform.x;
      this.nodeY = (this.collidingNode.y * this.transform.k) + this.transform.y;
    } else {
      this.nodeX = 0;
      this.nodeY = 0;
    }
  }
  labelHover(d, state) {
    // Shows label on hover
    if (this.labelhoverDisabled) return;
    var el = document.querySelector(`#label-${d.id}`);
    if (el) {
      el.style.opacity = state;
    }
  }
};

export default Links;



// WEBPACK FOOTER //
// ./assets/js/source/links.js